import { useEffect } from 'react'

import { registerNotify } from './notificationController'
import { useNotify } from './useNotify'

/**
 * Mount ONCE under the GluestackUIProvider (which provides the gluestack
 * ToastProvider). It wires the live `notify` fn into the imperative bridge so
 * module-level `notify()` (sagas/services) works. Renders nothing.
 */
export function NotificationHost(): null {
    const notify = useNotify()

    useEffect(() => {
        registerNotify(notify)
        return () => registerNotify(null)
    }, [notify])

    return null
}

NotificationHost.displayName = 'NotificationHost'
